module.exports = __webpack_public_path__ + "img/sPut.4139880f.svg";